import { useEffect, useState } from "react";
import { Phone, Mail, Calendar, Check } from "lucide-react";
import { api } from "@/lib/api";
import { PHONE, PHONE_HREF, EMAIL, GOOGLE_MEET_LINK } from "@/lib/config";
import { toast } from "sonner";

const field = "w-full bg-charcoal border border-white/15 px-3 py-2.5 text-sm text-cream outline-none focus:border-gold placeholder:text-cream/40";

export default function Contact() {
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", productInterest: "", message: "" });
  useEffect(() => window.scrollTo(0, 0), []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.postConsultation(form); setDone(true); } catch (e) { toast.error("Something went wrong."); }
  };

  return (
    <div className="pt-16" data-testid="contact-page">
      <div className="bg-charcoal border-b border-white/10">
        <div className="max-w-[1100px] mx-auto px-5 py-14">
          <p className="overline">Get In Touch</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">Talk to a Recovery Expert</h1>
        </div>
      </div>
      <div className="max-w-[1100px] mx-auto px-5 py-14 grid lg:grid-cols-2 gap-12">
        <div className="space-y-6">
          <p className="text-cream/75 leading-relaxed">Have a question or want guidance choosing your setup? Our specialists are here to help — by phone, email, or a free video consultation.</p>
          <a href={PHONE_HREF} className="flex items-center gap-3 text-cream hover:text-gold"><Phone className="text-gold" size={20} /> {PHONE}</a>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-cream hover:text-gold"><Mail className="text-gold" size={20} /> {EMAIL}</a>
          <a href={GOOGLE_MEET_LINK} target="_blank" rel="noreferrer" data-testid="contact-book-link"
            className="inline-flex items-center gap-2 bg-gold text-espresso px-6 py-3 font-medium hover:bg-amber transition-colors">
            <Calendar size={18} /> Book a Video Call
          </a>
        </div>
        <div className="bg-charcoal border border-white/10 p-8">
          {done ? (
            <div className="text-center py-8" data-testid="contact-success">
              <div className="w-14 h-14 rounded-full bg-forest/20 flex items-center justify-center mx-auto mb-4"><Check className="text-forest" size={28} /></div>
              <h3 className="font-serif text-2xl text-cream">Message sent!</h3>
              <p className="text-cream/65 mt-2">We'll be in touch within one business day.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <input data-testid="contact-name" required placeholder="Full name" className={field} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="contact-email" required type="email" placeholder="Email" className={field} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input data-testid="contact-phone" placeholder="Phone (optional)" className={field} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <input data-testid="contact-interest" placeholder="Product interest" className={field} value={form.productInterest} onChange={(e) => setForm({ ...form, productInterest: e.target.value })} />
              <textarea data-testid="contact-message" required placeholder="How can we help?" rows={4} className={field} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              <button data-testid="contact-submit" type="submit" className="w-full bg-gold text-espresso py-3.5 font-medium hover:bg-amber transition-colors">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
